import React, { ReactElement } from "react";

import { Guid } from "@/Common/Models/Guid";
import { useAvailableFlowsheetTemplates } from "@/Flowsheets/Hooks/useAvailableFlowsheetTemplates";

interface ICreateFlowsheetButtonProps {
    /**
     * The patient ID.
     */
    patientId: Guid;
    encounterId: Guid;
    children: React.ReactNode;
}

function CreateFlowsheetButton({ patientId, encounterId, children }: Readonly<ICreateFlowsheetButtonProps>): ReactElement {
    const { data: flowsheetTemplates } = useAvailableFlowsheetTemplates({ encounterId, patientId });

    return <>{flowsheetTemplates?.any() ? children : null}</>;
}

export { CreateFlowsheetButton };
